import { useHandleChange } from "@arelia-hooks/formikHooks";
import { FormikProps, useFormik } from "formik";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { CustomerDetails } from "src/features/hq/customers/models";
import LabelDetailsPresenter from "./LabelDetailsPresenter";

type Props = {
  bandName: string;
  location: string;
  update: (cutomerUpdates: Partial<CustomerDetails>) => void;
};

export type EditForm = {
  bandName: string;
  location: string;
};

export default function LabelDetailsContainer({ bandName, location, update }: Props) {
  const [searchParams] = useSearchParams();
  const [editing, setEditing] = useState(searchParams.get("edit") === "true");

  const mapper = ({ location, bandName }: EditForm) => ({
    band: {
      name: bandName,
      location
    }
  } as Partial<CustomerDetails>);

  const submitUpdates = (updates: EditForm) => update(mapper(updates));

  const formik: FormikProps<EditForm> = useFormik<EditForm>({
    initialValues: {
      bandName,
      location
    },
    onSubmit: submitUpdates,
    enableReinitialize: true,
  });

  const handeChange = useHandleChange<EditForm>(formik);

  return <LabelDetailsPresenter
    formik={formik}
    handeChange={handeChange}
    editing={editing}
    setEditing={setEditing}
  ></LabelDetailsPresenter>;
}